import {Fragment} from 'react'
import {Outlet} from 'react-router-dom'

import Stack from '@mui/material/Stack'
import Nav from './dashboard/Nav'
import Header from './Header'

import './dashboardLayout.scss'

const DashboardLayout = () => (
  <Fragment>
    <Header />
    <Stack className='dashboard-layout' direction='row' sx={{justifyContent: 'space-between'}}>
      <Nav />
      <Stack className='dashboard-content' sx={{justifyContent: 'center', alignItems: 'center', width: '100%'}}>
        <Outlet />
      </Stack>
    </Stack>
  </Fragment>
)

export default DashboardLayout
